export default __webpack_public_path__ + "static/nessus-c790bdd076b1d5231ecda7285eed2bf7.jpg";